import api from '../api'
import { WIN_CRITERIA_QUIZ_ITEMS } from '@/constants/setupQuiz'
import { formatQuizApiError, QUIZ_API_TIMEOUT_MS } from '@/utils/quizApiErrors'

export function collectQuizAnswers(quizItems, quizDraft) {
  return quizItems.map((item) => ({
    question: item.question,
    answer: String(quizDraft[item.id] ?? '').trim(),
  }))
}

export function validateQuizRequired(quizItems, quizDraft) {
  return quizItems.filter((item) => !item.optional && !String(quizDraft[item.id] ?? '').trim())
}

export function quizErrorMessage(error, fallback = 'Не удалось сгенерировать критерии.') {
  return formatQuizApiError(error, fallback)
}

export async function submitWinCriteriaFromQuiz(answers, { onSaveProgress } = {}) {
  const { data } = await api.post('win-criteria/from-quiz/', { answers }, { timeout: QUIZ_API_TIMEOUT_MS })
  const list = Array.isArray(data.criteria) ? data.criteria : []
  if (!list.length) {
    return { ok: false, error: 'Сервис вернул пустой список критериев.' }
  }

  const toSave = list
    .map((c) => ({
      name: String(c.name || '').trim(),
      description: String(c.description || '').trim(),
      criticality_percent: Math.max(0, Math.min(100, Number(c.criticality_percent) || 0)),
    }))
    .filter((p) => p.name)

  if (!toSave.length) {
    return { ok: false, error: 'В ответе нет ни одного критерия с непустым названием.' }
  }

  let done = 0
  const total = toSave.length
  for (const payload of toSave) {
    await api.post('/win-criteria/', payload)
    done += 1
    onSaveProgress?.({ done, total })
  }

  return { ok: true, savedCount: toSave.length }
}

export { WIN_CRITERIA_QUIZ_ITEMS }
